import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  formInputLabel: {
    padding: 0,
    marginBottom: 8,
    fontWeight: '600 !important',
    fontSize: 16,
    lineHeight: '24px',
  },
  textFieldStyle: {
    '&.MuiTextField-root': {
      width: '100%',
    },
    '& .MuiInputBase-input': {
      padding: '16px 14px',
    },
  },
  wrapFormInput: {
    marginTop: 0,
    position: 'relative',
  },
  wrapNote: {
    marginTop: 16,
    display: 'flex',
    justifyContent: 'center',
  },
  lockIcon: {
    '&.MuiSvgIcon-root': {
      width: 20,
      height: 20,
      marginRight: 5,
    },
  },
  textByDefault: {},
}));

export default useStyles;
